// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Permissions
import { Resource, usePermissions } from '@/modules/Permissions';

// Components
import { StyledWrapper } from './FeedsListStyles';
import { Table } from '@/ui';
import { getFeedsTableColumns } from './columns';
import { Pagination } from '@/components';
import { FeedsFiltersContainer } from '../../containers';

// Models
import { IFeed } from '@/models/feeds.model';

type TFeedsList = {
  list: IFeed[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
  onEdit: (item: IFeed) => void;
  onDelete: (item: IFeed) => void;
};

const FeedsList = ({ list, currentPage, total, onPageChange, onDelete, onEdit }: TFeedsList) => {
  const { t } = useTranslation(['seo']);
  const { canManage } = usePermissions();

  return (
    <StyledWrapper>
      <Table
        columns={getFeedsTableColumns({ t, onDelete, onEdit, canManage: canManage(Resource.FEED) })}
        loading={false}
        dataSource={list}
        rowKey="id"
        components={{
          header: {
            wrapper: FeedsFiltersContainer,
          },
        }}
      />
      <Pagination hideOnSinglePage current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default FeedsList;
